const CrawlerHeader = ({ filter, setFilter, search, setSearch }) => {
  return (
    <div className="d-flex bg-white headerRadius5 headerContainer align-items-center justify-content-between mb-10">
      <div className="d-flex align-items-center gap10 bg-white radius5 px-20 py-2px searchBar">
        <img src="./icons/search.svg" alt="search" height={16} width={16} />
        <input
          type="search"
          placeholder="Recherche avancée"
          className="inputSearch border-0"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>
    </div>
  );
};

export default CrawlerHeader;
